//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"Filename",1,0],[0,"OnlyUseExistingComponents",1,0],[0,"Output",1,0]],[[[],"AcceptAll",{},0,0],[[],"RejectAll",{},0,0],[[],"AcknowledgeAll",{},0,0],[[],"IgnoreAll",{},0,0],[["id"],"AcknowledgeResponse",{},1,0],[["id"],"IgnoreResponse",{},1,0],[["id"],"AcceptChange",{},1,0],[["id"],"RejectChange",{},1,0],[["id"],"RejectBoardChange",{},1,0],[["id"],"AcceptBoardChange",{},1,0],[["id","comment"],"AddNewComment",{},2,0],[[],"PreviewChanges",{},0,0],[[],"UnhighlightAll",{},0,0],[[],"ReadImportFile",{},0,0],[[],"SetExistingPart",{R_:{existingPartTag:"DisplayableObject"}},0,0],[["updated"],"SetBoardUpdated",{},1,0],[[],"CancelIncrementReview",{},0,0],[[],"ClearProcessedIncrementalGroupVec",{},0,0]],[]];
SPLM.PcbExchange.IncrementalImportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.IncrementalImportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;